import React, { useState } from 'react';
import EtCelebrateImprintIconSVGComp from "@/assets/img/icons/svgComp/EtCelebrateImprintIcon1SVGComp";

// 25 Apr 2025
import { useGetUserMagicMomentsQuery } from '@/features/userMagicMoments/userMagicMomentsApiSlice';  

// 26 Apr 2025
import { useGetUserActionsQuery } from '@/features/userActions/userActionsApiSlice'

import { useGetUserAccomplishmentWeeklysQuery } from '@/features/userAccomplishmentWeekly/userAccomplishmentWeeklysApiSlice';


import EtWabReflectionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabReflectionIcon1SVGComp"
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp" 
import EtWabCreationIcon1SVGComp  from "@/assets/img/icons/svgComp/EtWabCreationIcon1SVGComp" 
import EtWabContributionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabContributionIcon1SVGComp"
import EtWabImpactIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabImpactIcon1SVGComp"
import EtWabWinIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabWinIcon1SVGComp"
import EtWabChallengeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabChallengeIcon1SVGComp"
import EtHmUserMagicMomentsIcon1SVGComp from '@/assets/img/icons/svgComp/EtHmUserMagicMomentsIcon1SVGComp'

// 26 Apr 2025
import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp"
import EtConversationAllIcon1SVGComp from '@/assets/img/icons/svgComp/EtConversationAllIcon1SVGComp'
import EtConversationContactIcon1SVGComp from '@/assets/img/icons/svgComp/EtConversationContactIcon1SVGComp'
import EtWabIntentionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabIntentionIcon1SVGComp"
import EtWabGratitudeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabGratitudeIcon1SVGComp"

import {
  PlusIcon,
  MinusIcon,
  TrashIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline"

// 27 Apr 2025
import EtTranscriptSection from './EtTranscriptSection'
import EtUserAccomplishmentWeeklyPadCelebrateComp from '@/features/userAccomplishmentWeekly/EtUserAccomplishmentWeeklyPadCelebrateComp';

import { CircularProgressbarWithChildren } from 'react-circular-progressbar'
import moment from 'moment';  
import { getTimeSince } from "@/utils/EtGetTimeSince"; 
import CountUp from 'react-countup'; // Add at top imports


const EtTrinityWebCelebrateMagicLog = ({username, userId, userOrgId}) => {
  // Author - Atul Pandey
  // First Created - 09 Apr 2025
  // Purpose to act as the home page for Trinity Landing - Celebrate - Magic Log
  // Updated - 19 Apr 2025 - added the main sections - Moments, Transcript and Journey
  // Updated - 25 Apr 2025 - added the moments section features
  // Updated - 26 Apr 2025 - added the transcript section features
  // Updated - 27 Apr 2025 - refactored DRY code with EEtTranscriptSection component and extractNotes function
  // Updated - 07 Dec 2025 - time chip date fences refined - to align with latest comps such as Reflection Center, Morning Habits

  // 0 - Validate props:
  // console.log('userId', userId)

  // 1a - State variables
  const [activeTab, setActiveTab] = useState('moments'); // moments | transcript | journey
  const [activePeriod, setActivePeriod] = useState('week'); // today | week | month | quarter | year

  
  const [expandedMoments, setExpandedMoments] = useState({}); // 25 Apr 2025 - Moment Cards
  const [showActionDetails, setShowActionDetails] = useState(false); // 26 Apr 2025 - Action Cards 
  const [showConversationDetails, setShowConversationDetails] = useState(false); // 26 Apr 2025 - Conversation Cards 
  const [showCreationDetails, setShowCreationDetails] = useState(false); // 26 Apr 2025 - Creation Cards 
  const [showContributionDetails, setShowContributionDetails] = useState(false); // 26 Apr 2025 - Contribution Cards 
  const [showImpactDetails, setShowImpactDetails] = useState(false); // 26 Apr 2025 - Impact Cards 
  const [showWinDetails, setShowWinDetails] = useState(false); // 26 Apr 2025 - Win Cards 
  const [showChallengeWABDetails, setShowChallengeWABDetails] = useState(false); // 26 Apr 2025 - Challenge Cards 
  const [showIntentionDetails, setShowIntentionDetails] = useState(false); // 26 Apr 2025 - Intention Cards 
  const [showGratitudeDetails, setShowGratitudeDetails] = useState(false); // 26 Apr 2025 - Gratitude Cards 


  // 2a - Icon Map for Source Types - 25 Apr 2025
  const sourceTypeIcons = {
    Reflection: EtWabReflectionIcon1SVGComp,
    Conversation: EtWabConversationIcon1SVGComp,
    Creation: EtWabCreationIcon1SVGComp,
    Contribution: EtWabContributionIcon1SVGComp,
    Impact: EtWabImpactIcon1SVGComp,
    Win: EtWabWinIcon1SVGComp,
    Challenge: EtWabChallengeIcon1SVGComp,
    HiddenMagic: EtHmUserMagicMomentsIcon1SVGComp, // When no sourceType
  };

  // 2b - Fetch Magic Moments and other data from RTK queries
  const {
    data: magicMomentsData,
    isLoading: isLoadingMagicMoments,
    isError: isErrorMagicMoments,
    error: errorMagicMoments,
  } = useGetUserMagicMomentsQuery(userId);

  const { 
    data: userActionsData,
    isLoading: isLoadingActions,
    isError: isErrorActions,
    error: errorActions,

  } = useGetUserActionsQuery() // 26 Apr 2025

  const {
    data: userWeeklyAccomplishmentData,
    isLoading: isLoadingAccomplishment,
    isError: isErrorAccomplishment,
    error: errorAccomplishment,
  } = useGetUserAccomplishmentWeeklysQuery();

    // 2c - Define all magic moments
  const allMagicMoments = magicMomentsData?.ids?.map(id => magicMomentsData.entities[id]) || [];

  const allUserActions = userActionsData?.ids
    ?.map(id => userActionsData.entities[id])
    ?.filter(item => item.userId?._id === userId) || []

  // console.log('allMagicMoments', allMagicMoments)
  // console.log('userActions', allUserActions)

  // 2d - Helper function: check if a moment falls into selected time period

  // 07 Dec 2025
  // --- Time Range Definitions (Aligned with Reflection Center) ---
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  const startOfWeek = moment().isoWeekday(1).startOf("day");
  const endOfWeek = endOfToday;

  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().isSame(now, "month")
    ? endOfToday
    : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, "quarter")
    ? endOfToday
    : moment().endOf("quarter");

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, "year")
    ? endOfToday
    : moment().endOf("year");

  // --- Time-Based Filtering Helper ---
  const filterByTime = (items, dateExtractor, start, end) =>
    items.filter(item => {
      const d = moment(dateExtractor(item));
      return d.isBetween(start, end, null, "[]");
    });


  // const isMomentInSelectedPeriod = (dateString) => {
  //   const now = moment();
  //   const momentDate = moment(dateString);

  //   switch (activePeriod) {
  //     case 'today':
  //       return momentDate.isSame(now, 'day');
  //     case 'week':
  //       return momentDate.isSame(now, 'week');
  //     case 'month':
  //       return momentDate.isSame(now, 'month');
  //     case 'quarter':
  //       return momentDate.isSame(now, 'quarter');
  //     case 'year':
  //       return momentDate.isSame(now, 'year');
  //     default:
  //       return true;
  //   }
  // };

  // 2e - Filtered data

  // 07 Dec 2025
  // const filteredMagicMoments = allMagicMoments.filter(moment => isMomentInSelectedPeriod(moment.magicMomentDate));

  let filteredMagicMoments = [];

  switch (activePeriod) {
    case "today":
      filteredMagicMoments = filterByTime(allMagicMoments, m => m.magicMomentDate, startOfToday, endOfToday);
      break;
    case "week":
      filteredMagicMoments = filterByTime(allMagicMoments, m => m.magicMomentDate, startOfWeek, endOfWeek);
      break;
    case "month":
      filteredMagicMoments = filterByTime(allMagicMoments, m => m.magicMomentDate, startOfMonth, endOfMonth);
      break;
    case "quarter":
      filteredMagicMoments = filterByTime(allMagicMoments, m => m.magicMomentDate, startOfQuarter, endOfQuarter);
      break;
    case "year":
      filteredMagicMoments = filterByTime(allMagicMoments, m => m.magicMomentDate, startOfYear, endOfYear);
      break;
    case "all":
    default:
      filteredMagicMoments = allMagicMoments;
      break;
  }


  // const filteredActions = allUserActions?.filter(action => isMomentInSelectedPeriod(action.updatedAt))

  // 2f - Extract and aggregate all actions
  const today = new Date();

  const userWeeklyAccomplishments = userWeeklyAccomplishmentData?.ids?.map((id) => userWeeklyAccomplishmentData?.entities[id]) || [];

  const filteredCurrentWeekAccomplishment = userWeeklyAccomplishments?.filter(
    (item) => {
      const weekStart = new Date(item.weekStarting);
      const weekEnd = new Date(item.weekEnding);
      return item.userId._id === userId &&
        weekStart <= today && today <= weekEnd;
    }
  ) || [];
  // console.log('filteredCurrentWeekAccomplishment', filteredCurrentWeekAccomplishment)

  // 2e.1 - Group accomplishment action data by trail and session
  const groupedAccomplishments = {};

  filteredCurrentWeekAccomplishment?.forEach(accomplishment => {
    const accomplishmentId = accomplishment._id;
    
    if (!groupedAccomplishments[accomplishmentId]) {
      groupedAccomplishments[accomplishmentId] = {
        accomplishmentId,
        weekStarting: accomplishment.weekStarting,
        weekEnding: accomplishment.weekEnding,
        userAccomplishmentWeeklyName: accomplishment.userAccomplishmentWeeklyName,
        userId: accomplishment.userId,
        userReflectionNotes: accomplishment.userReflectionNotes || [],
        userConversationNotes: accomplishment.userConversationNotes || [],
        userCreationWABNotes: accomplishment.userCreationWABNotes || [],
        userContributionNotes: accomplishment.userContributionNotes || [],
        userImpactNotes: accomplishment.userImpactNotes || [],
        userWinNotes: accomplishment.userWinNotes || [],
        userChallengeWABNotes: accomplishment.userChallengeWABNotes || [],
        userIntentionNotes: accomplishment.userIntentionNotes || [],
        userGratitudeNotes: accomplishment.userGratitudeNotes || [],
        trails: {}
      };
    }

    accomplishment.userAccomplishmentActions.forEach(action => {
      const trailId = action.trailId._id;
      if (!groupedAccomplishments[accomplishmentId].trails[trailId]) {
        groupedAccomplishments[accomplishmentId].trails[trailId] = {
          trailName: action.trailId.trailName,
          trailDesc: action.trailId.trailDesc,
          pic: action.trailId.pic,
          sessions: {}
        };
      }

      const sessionId = action.sessionId._id;
      if (!groupedAccomplishments[accomplishmentId].trails[trailId].sessions[sessionId]) {
        groupedAccomplishments[accomplishmentId].trails[trailId].sessions[sessionId] = {
          sessionName: action.sessionId.sessionName,
          sessionDesc: action.sessionId.sessionDesc,
          sessionSequence: action.sessionId.sessionSequence,
          sessionIntro: action.sessionId.sessionIntro,
          sessionOutro: action.sessionId.sessionOutro,
          pic: action.sessionId.pic,
          actions: []
        };
      }

      groupedAccomplishments[accomplishmentId].trails[trailId].sessions[sessionId].actions.push({
        userActionId: action.userActionId,
        userActionName: action.userActionName,
        userActionProgress: action.userActionProgress,
        userActionProgressBadge: action.userActionProgressBadge,
        userActionProgressTrail: action.userActionProgressTrail, // Progress trail for past % updates
      });
    });
  });

  // 2e.2 - Grouped object to array
  const groupedAccomplishmentsArray = Object.keys(groupedAccomplishments)?.map(accomplishmentId => {
    const accomplishment = groupedAccomplishments[accomplishmentId];
    return {
      accomplishmentId,
      weekStarting: accomplishment.weekStarting,
      weekEnding: accomplishment.weekEnding,
      userAccomplishmentWeeklyName: accomplishment.userAccomplishmentWeeklyName,
      userId: accomplishment.userId,
      userReflectionNotes: accomplishment.userReflectionNotes || [],
      userConversationNotes: accomplishment.userConversationNotes || [],
      userCreationWABNotes: accomplishment.userCreationWABNotes || [],
      userContributionNotes: accomplishment.userContributionNotes || [],
      userImpactNotes: accomplishment.userImpactNotes || [],
      userWinNotes: accomplishment.userWinNotes || [],
      userChallengeWABNotes: accomplishment.userChallengeWABNotes || [],
      userIntentionNotes: accomplishment.userIntentionNotes || [],
      userGratitudeNotes: accomplishment.userGratitudeNotes || [],
      trails: Object.keys(accomplishment.trails).map(trailId => {
        const trail = accomplishment.trails[trailId];
        return {
          trailId,
          trailName: trail.trailName,
          trailDesc: trail.trailDesc,
          pic: trail.pic,
          sessions: Object.keys(trail.sessions).map(sessionId => {
            const session = trail.sessions[sessionId];
            return {
              sessionId,
              sessionName: session.sessionName,
              sessionDesc: session.sessionDesc,
              sessionSequence: session.sessionSequence,
              sessionIntro: session.sessionIntro,
              sessionOutro: session.sessionOutro,
              pic: session.pic,
              actions: session.actions,
            };
          }),
        };
      }),
    };
  });
  
  // 2e.3 - Aggregate all actions into one array
  const allAccomplishmentActions = [];

  groupedAccomplishmentsArray.forEach(accomplishment => {
    accomplishment?.trails?.forEach(trail => {
      trail?.sessions?.forEach(session => {
        session?.actions?.forEach(action => {
          allAccomplishmentActions.push({
            userActionId: action.userActionId,
            userActionName: action.userActionName,
            userActionProgress: action.userActionProgress,
            userActionProgressBadge: action.userActionProgressBadge,
            userActionProgressTrail: action.userActionProgressTrail || [],
          });
        });
      });
    });
  });

  // console.log('allAccomplishmentActions', allAccomplishmentActions)

  // 1️⃣ First, filter once and store
  const filteredActions = allAccomplishmentActions.filter(
    (action) => action.userActionProgressBadge !== "Lagged!"
  );

  // 2f.1 - Conversations Data - Get the current week accomplishment (first and only one)
  const currentAccomplishment = filteredCurrentWeekAccomplishment?.[0];
  const userConversationNotes = currentAccomplishment?.userConversationNotes || [];

  const userConversationContactNotes = userConversationNotes[0]?.userConversationNoteId?.userConversationContactNotes || [];
  const userConversationAllNotes = userConversationNotes[0]?.userConversationNoteId?.userConversationAllNotes || [];

  const allConversations = [
    ...userConversationContactNotes.map(note => ({ ...note, conversationSourceType: 'Contact' })),
    ...userConversationAllNotes.map(note => ({ ...note, conversationSourceType: 'All' })),
  ];

  // 07 Dec 2025
  const filteredConversations = (() => {
  const dateExtractor = c =>
    c.userConversationAllNoteDate || c.userConversationContactNoteDate;

  switch (activePeriod) {
    case "today":
      return filterByTime(allConversations, dateExtractor, startOfToday, endOfToday);
    case "week":
      return filterByTime(allConversations, dateExtractor, startOfWeek, endOfWeek);
    case "month":
      return filterByTime(allConversations, dateExtractor, startOfMonth, endOfMonth);
    case "quarter":
      return filterByTime(allConversations, dateExtractor, startOfQuarter, endOfQuarter);
    case "year":
      return filterByTime(allConversations, dateExtractor, startOfYear, endOfYear);
    case "all":
    default:
      return allConversations;
  }
})();

  // const filteredConversations = allConversations.filter(conversation =>
  //   isMomentInSelectedPeriod(conversation.userConversationAllNoteDate || conversation.userConversationContactNoteDate)
  // );

  // console.log('filteredConversations', filteredConversations)

  

  // 2g - Creations Data
  const filteredCreations = [];

  filteredCurrentWeekAccomplishment?.forEach(item => {
    item?.userCreationWABNotes?.forEach(noteWrapper => {
      const userCreationRecords = noteWrapper?.userCreationWABNoteId?.userCreationRecords || [];
      userCreationRecords.forEach(record => {
        if (record?.userCreationId) {
          filteredCreations.push(record.userCreationId);
        }
      });
    });
  });

  const creationTypeCounts = {};

  filteredCreations.forEach(creation => {
    const typeName = creation.userCreationType?.creationTypeName || 'Unknown';
    creationTypeCounts[typeName] = (creationTypeCounts[typeName] || 0) + 1;
  });

  // console.log('filteredCreations', filteredCreations)
  // console.log('creationTypeCounts', creationTypeCounts)

  // // 2h - Data using extractNotes
  const filteredContributions = extractNotes(
    filteredCurrentWeekAccomplishment,
    "userContributionNotes", 
    "userContributionAllNotes", 
    "userContributionContactNotes", 
    "contributionSourceType"
  );
  
  const filteredImpacts = extractNotes(
    filteredCurrentWeekAccomplishment,
    "userImpactNotes", 
    "userImpactAllNotes", 
    "userImpactContactNotes", 
    "impactSourceType"
  );
  
  const filteredWins = extractNotes(
    filteredCurrentWeekAccomplishment,
    "userWinNotes", 
    "userWinAllNotes", 
    "userWinContactNotes", 
    "winSourceType"
  );
  
  const filteredChallengeWABs = extractNotes(
    filteredCurrentWeekAccomplishment,
    "userChallengeWABNotes", 
    "userChallengeWABAllNotes", 
    "userChallengeWABContactNotes", 
    "challengeWABSourceType"
  );
  
  const filteredIntentions = extractNotes(
    filteredCurrentWeekAccomplishment,
    "userIntentionNotes", 
    "userIntentionAllNotes", 
    "userIntentionContactNotes", 
    "intentionSourceType"
  );
  
  const filteredGratitudes = extractNotes(
    filteredCurrentWeekAccomplishment,
    "userGratitudeNotes", 
    "userGratitudeAllNotes", 
    "userGratitudeContactNotes", 
    "gratitudeSourceType"
  );
  
  // 3 - Prepare counts per SourceType
  const sourceTypeCounts = filteredMagicMoments.reduce((acc, moment) => {
    const type = moment.sourceType ? moment.sourceType.replace('User', '') : "HiddenMagic";
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  // 4 - Helper to clean and pluralize source type labels
  const getCleanPluralSourceType = (sourceType) => {
    if (!sourceType) return "Hidden Magics"; // Special case
    let clean = sourceType.replace('User', '').replace('WAB', '').trim(); // Remove 'User' and 'WAB'
    if (!clean.endsWith('s')) {
      clean += 's'; // Pluralize if not already
    }
    return clean;
  };

  // 5 - Function for action progress badge bg-color
  const getBadgeClass = (badge) => {
    switch (badge) {
      case "Accomplished!":
        return "bg-lime-600 text-white";
      case "Moved!":
        return "bg-lime-400";
      case "Persisted!":
        return "bg-yellow-300";
      case "Lagged!":
        return "bg-red-600 text-white";
      default:
        return "bg-gray-200"; // Default case if no badge matches
    }
};


  return (
    <div className='font-poppins'>
      {/* Header */}
      <div className='m-1 p-1 border-b-4 border-orange-600'>
          <div className='flex justify-start items-center'>
              <div className='flex justify-center items-center w-10 h-10 rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md'>
                  <EtCelebrateImprintIconSVGComp className="h-7 w-7 text-white" />
              </div>
              <div className='mx-1 px-1 pb-2'>
                  <p className="text-md sm:text-xl font-semibold mb-1">Magic Log – The Imprint</p>
                  {/* <p className="text-[10px] sm:text-[13px] text-gray-500">Moments of pride and magic added to your Imprint.</p> */}
                  {/* <p className="text-[10px] sm:text-[12px] xl:text-[13px] text-gray-500">Savor the proud moments you added to your Imprint.</p> */}
                  <p className="text-[10px] sm:text-[12px] xl:text-[13px] text-gray-500">Savor the proud moments you added!</p>
                  {/* <p className="text-[10px] sm:text-[12px] xl:text-[13px] text-gray-500">Savor the pride you added to your Imprint.</p> */}
                  {/* <p className="text-[10px] sm:text-[12px] xl:text-[13px] text-gray-500">Savor the magic you weaved!</p> */}
              </div>
          </div>
      </div>

      {/* Top Tabs: Moments | Transcript | Journey */}
      <div className="flex justify-start space-x-4 border-b border-orange-300 mb-4 mt-2">
        {['moments', 'transcript', 'journey'].map(tab => (
          <button
            key={tab}
            className={`text-sm font-semibold px-3 py-1 rounded-t ${
              activeTab === tab ? 'bg-orange-200 text-orange-800' : 'text-gray-500'
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === 'moments' && 'Moments'}
            {tab === 'transcript' && 'Transcript'}
            {tab === 'journey' && 'Journey'}
          </button>
        ))}
      </div>

      {/* Time Filter Chips */}
      <div className="flex flex-wrap gap-1 xl:gap-2 mb-3 text-[9px] xl:text-xs font-semibold">
        {['today', 'week', 'month', 'quarter', 'year'].map(period => (
          <button
            key={period}
            className={`px-2 py-1 rounded-full border ${
              activePeriod === period
                ? 'bg-orange-600 text-white'
                : 'bg-gray-100 text-gray-600'
            }`}
            onClick={() => setActivePeriod(period)}
          >
            {period === 'today' && 'Today'}
            {period === 'week' && 'This Week'}
            {period === 'month' && 'This Month'}
            {period === 'quarter' && 'This Qtr'}
            {period === 'year' && 'This Year'}
          </button>
        ))}
      </div>

      {/* Placeholder Display Blocks */}
      {/* <div className="rounded bg-gray-100 border border-orange-200 shadow-inner text-sm text-gray-500"> */}
      <div className="">
        {/* {activeTab === 'moments' && `✨ Coming soon: Magic Moments from ${activePeriod}`} */}
        {/* {activeTab === 'transcript' && `📜 Transcript of your accomplishments for ${activePeriod}`} */}

        {activeTab === 'moments' && (
          <div className="space-y-1 mt-2 overflow-y-auto max-h-[70vh] rounded bg-gray-200 m-1 p-1 shadow-lg shadow-black">
            
            {isLoadingMagicMoments && (
              <p className="text-sm text-gray-500">Loading your magic moments...</p>
            )}
            
            {isErrorMagicMoments && (
              <p className="text-sm text-red-500">Error loading magic moments: {errorMagicMoments?.message}</p>
            )}
            
            {!isLoadingMagicMoments && filteredMagicMoments.length === 0 && (
              <div className="bg-white border border-orange-300 rounded shadow-md p-3 space-y-2">
                  <p className="text-sm text-gray-800 m-1 p-1">
                    No magic moments ✨ recorded yet for <span className={`px-2 py-1 rounded-full border 
                bg-orange-600 text-white capitalize`}>{activePeriod}</span>.
                  </p>
              </div>
              
            )}

            {/* Summary Card */}
            {filteredMagicMoments.length > 0 && (
              <div className="bg-white border border-orange-400 rounded shadow-md p-4 mb-2">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-md xl:text-lg font-bold text-orange-800">Magic Moments Board</h3>
                  {/* <div className="flex justify-center items-center bg-orange-50 border border-orange-600 rounded-full w-10 h-10">
                    <p className="font-bold text-md text-orange-800">
                      <CountUp end={filteredMagicMoments.length} duration={1} />
                    </p>
                  </div> */}
                  <div className="flex justify-center items-center bg-orange-50 border border-orange-600 rounded-full w-10 h-10 animate-[bounce_2s_ease-in-out_1]">
                    <p className="font-bold text-md text-orange-800">
                      <CountUp key={filteredMagicMoments.length} start={0} end={filteredMagicMoments.length} duration={1} />
                    </p>
                  </div>
                </div>

                {/* Per Source Type */}
                <div className="space-y-2">
                {Object.entries(sourceTypeCounts).map(([type, count], index) => {
                  const label = getCleanPluralSourceType(type); // <-- Pass full raw type
                  const cleanTypeForIcon = type.replace('User', '').replace('WAB', '').trim(); // Clean it separately for icons
                  const IconComponent = sourceTypeIcons[cleanTypeForIcon] || EtHmUserMagicMomentsIcon1SVGComp;
                    
                  return (
                    <div key={type} className="grid grid-cols-7 items-center gap-2 bg-gray-50 px-3 py-2 rounded border border-gray-200 shadow-sm">
                      {/* Left: Icon and Label */}
                      <div className="col-span-4 flex items-center space-x-2">
                        <p className="text-xs font-semibold text-gray-700">{`${index + 1}.`}</p>
                        <IconComponent className="h-5 w-5 text-orange-600" />
                        <p className="text-sm font-semibold text-gray-700">{label}</p>
                      </div>
              
                      {/* Right: Animated Count */}
                      <div className="col-span-3 flex justify-end items-center">
                        <div className="flex justify-center items-center rounded-full w-8 h-8 bg-yellow-300">
                          <p className="font-bold text-sm">
                            <CountUp key={count} start={0} end={count} duration={1} />
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                  })}
                </div>
              </div>
            )}


            {filteredMagicMoments?.map((moment, index) => (
              <div
                key={moment.id}
                className="bg-white border border-orange-300 rounded shadow-md p-3 space-y-2"
              >
                {/* Title Row */}
                <div className="flex justify-between items-center border-b mb-2 pb-2">
                   {/* Left: Icon */}
                  <div className="flex justify-center items-center w-8 h-8 rounded-full">
                    {(() => {
                      const sourceTypeClean = moment.sourceType ? moment.sourceType.replace('User', '').replace('WAB', '').trim() : "HiddenMagic";
                      const IconComponent = sourceTypeIcons[sourceTypeClean] || EtHmUserMagicMomentsIcon1SVGComp;
                      return <IconComponent className="h-6 w-6 text-orange-600" />;
                    })()}
                  </div>

                  {/* Middle: SourceType badge */}
                  <div className="bg-yellow-300 text-gray-800 px-2 py-1 rounded-full text-[10px] capitalize">
                    {moment.sourceType ? moment.sourceType.replace('User', '').replace('WAB', '').trim() : "Hidden Magic"}
                  </div>

                    {/* Right: Moment X of Y */}
                  <div className='flex justify-start items-center'>
                    <p className="font-bold text-orange-700 text-xs mx-1 px-1">
                      Moment
                    </p>
                    
                    <div className='flex justify-center items-center w-4 h-4 rounded-full border border-orange-300 bg-orange-50'>
                        <p className="font-bold text-[10px]">
                        {index + 1} 
                        </p>
                    </div>
                    
                    <p className="text-gray-700 text-[10px] mx-1 px-1">
                      of 
                    </p>

                    <div className='flex justify-center items-center w-4 h-4 rounded-full border border-orange-300 bg-orange-50'>
                        <p className="font-bold text-[10px]">
                        {filteredMagicMoments.length}
                        </p>
                    </div>

                  </div>
                </div>

                {/* Description */}
                {moment.magicMomentDesc && (
                  <div className="text-sm text-gray-600 relative">
                    {/* Collapsible Content */}
                    <div
                      className={`${expandedMoments[moment.id] ? '' : 'line-clamp-3'} transition-all duration-300 fix-nested-lists`}
                      dangerouslySetInnerHTML={{ __html: moment.magicMomentDesc }}
                    />

                    {/* Read More / Read Less Link */}
                    {moment.magicMomentDesc.length > 100 && (
                      <button
                        onClick={() => setExpandedMoments(prev => ({ ...prev, [moment.id]: !prev[moment.id] }))}
                        className="text-[10px] text-orange-500 underline mt-1"
                      >
                        {expandedMoments[moment.id] ? 'Read Less ▲' : 'Read More ▼'}
                      </button>
                    )}
                  </div>
                )}

                {/* Date Footer */}
                <div className="border-t mt-2 pt-2 flex justify-between items-center text-[10px] text-gray-400">
                {/* Logged At */}
                <p>
                  Logged at: {moment.magicMomentDate ? new Date(moment.magicMomentDate).toLocaleString() : "N/A"}
                </p>

                {/* Time Since */}
                <div className="bg-lime-200 px-2 py-[2px] rounded-full text-gray-800">
                  {moment.magicMomentUpdateDate ? getTimeSince(new Date(moment.magicMomentUpdateDate)) : "Just now"}
                </div>
              </div>

              </div>
            ))}
          </div>
        )}

        {activeTab === 'transcript' && (
          <div className="space-y-1 mt-2 overflow-y-auto max-h-[70vh] rounded bg-gray-200 m-1 p-1 shadow-lg shadow-black">
            {/* Header */}
            <div className="bg-white rounded shadow border border-orange-400 p-4 mb-2">
              <p className="text-sm xl:text-md font-bold text-orange-800">
                📜 Your Accomplishment Transcript for <span className={`px-2 py-1 rounded-full border 
                bg-orange-600 text-white text-xs mx-1 capitalize shadow shadow-black`}>{activePeriod}</span>
              </p>
              <p className="text-[10px] xl:text-xs text-gray-500 mt-1 mx-1 px-1">
                A live journal of your progress!
              </p>
            </div>

            {/* Action Summary Card with Toggle */}
            <div className="bg-white border border-orange-400 rounded shadow-md p-4 mb-2">
              <div className="grid grid-cols-2 justify-start items-center">
                <div className='col-span-1 flex justify-start items-center'>
                  <div
                  onClick={() => setShowActionDetails(prev => !prev)}
                  className="flex justify-center items-center w-6 h-6 text-orange-600 cursor-pointer rounded-full "
                  >
                      {showActionDetails ? (
                        <MinusIcon className="h-5 w-5" />
                      ) : (
                        <PlusIcon className="h-5 w-5" />
                      )}                 
                  </div>
                  <div className='flex flex-col justify-start items-start'>
                    <div className='mx-3'>
                      <EtWabActionIcon1SVGComp className='h-10 w-10 text-orange-600'/>
                    </div>
                    <p className='text-sm mx-1 px-1 font-bold text-orange-700'>Actions</p>
                    {/* <p className='text-sm mx-1 px-1 font-bold text-gray-800'>Actions</p> */}
                    {/* <p className='text-xs mx-1 px-2 text-white rounded-full bg-orange-600'>Actions</p> */}
                    
                  </div>
                </div>
                
                <div className='col-span-1'>
                  <div className='grid grid-cols-4 justify-start gap-2 text-[10px] xl:text-xs mb-1  '>
                    <div className='col-span-3'>
                      <p className="text-white inline-block rounded-full bg-lime-600 py-[1px]  px-2">Accomplished!</p>
                    </div>
                    <div className='col-span-1 mx-1'>
                        <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-100 border border-gray-300">
                          <p className="text-xs font-semibold">{filteredActions.filter(a => a.userActionProgressBadge === 'Accomplished!').length}</p>
                        </div>
                      {/* <p className="text-gray-800 font-bold text-sm py-[1px]  px-2">{filteredActions.filter(a => a.userActionProgressBadge === 'Accomplished!').length}</p> */}
                    </div>
                  </div>

                  <div className='grid grid-cols-4 justify-start gap-2 text-[10px] xl:text-xs mb-1  '>
                    <div className='col-span-3'>
                      <p className="text-gray-800 inline-block rounded-full bg-lime-400 py-[1px] my-1 px-2">Moved!</p>
                    </div>
                    <div className='col-span-1 mx-1'>
                        <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-100 border border-gray-300">
                          <p className="text-xs font-semibold">{filteredActions.filter(a => a.userActionProgressBadge === 'Moved!').length}</p>
                        </div>
                      {/* <p className="text-gray-800 font-bold text-sm py-[1px]  px-2">{filteredActions.filter(a => a.userActionProgressBadge === 'Moved!').length}</p> */}
                    </div>
                  </div>

                  <div className='grid grid-cols-4 justify-start gap-2 text-[10px] xl:text-xs mb-1  '>
                    <div className='col-span-3'>
                      <p className="text-gray-800 inline-block rounded-full bg-yellow-300 py-[1px] my-1 px-2">Persisted!</p>
                    </div>
                    <div className='col-span-1 mx-1'>
                        <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-100 border border-gray-300">
                          <p className="text-xs font-semibold">{filteredActions.filter(a => a.userActionProgressBadge === 'Persisted!').length}</p>
                        </div>
                      {/* <p className="text-gray-800 font-bold text-sm py-[1px] px-2">{filteredActions.filter(a => a.userActionProgressBadge === 'Persisted!').length}</p> */}
                    </div>
                  </div>

                  <div className='grid grid-cols-4 justify-start text-[10px] xl:text-xs mb-1 pt-2 mt-2 border-t'>
                    <div className='col-span-3'>
                      <p className="font-bold text-sm text-gray-800 inline-block py-[1px] my-1 px-2">Total</p>
                    </div>
                    <div className='col-span-1 flex justify-center items-center rounded-full bg-gray-100 shadow-md shadow-black'>
                      <p className="text-sm font-bold text-orange-600">{filteredActions.length}</p>
                    </div>
                  </div>
                  
                </div>
               
              </div>

              
            </div>

            {/* Insert the Action Tiles Renderer here */}
            {showActionDetails && filteredActions.length > 0 && (
              filteredActions.map((action, index) => {
                const actionProgress = action?.userActionProgress || 0
                const progressBadge = action?.userActionProgressBadge || ""
                return(
                <div
                  key={action.userActionId + index}
                  className="bg-white border border-orange-300 rounded shadow-md p-3 space-y-2"
                >
                  {/* Header Row */}
                  <div className="flex justify-between items-center border-b mb-2 pb-2">
                    {/* Left: Action index and badge */}
                      <div className="flex justify-start items-center space-x-2">
                        {/* Index */}
                        <div className="flex justify-center items-center w-6 h-6 rounded-full bg-orange-100 border border-orange-400">
                          <p className="text-xs font-bold text-orange-700">{index + 1}</p>
                        </div>
                        <div className='flex justify-start items-center'>
                          <div className='mx-1'>
                            <EtWabActionIcon1SVGComp className='h-8 w-8 text-orange-600'/>
                          </div>
                          <p className='text-xs mx-1 px-1 font-bold text-orange-700'>Action</p>

                        </div>
                      </div>

                      <div>
                      {/* Badge */}
                      <div className={`text-[10px] font-semibold px-2 py-[2px] capitalize rounded-full ${getBadgeClass(progressBadge)}`}>
                        {progressBadge}
                      </div>

                    </div>

                    {/* Right: Current Progress */}
                    <div className="flex justify-end items-center space-x-1">
                      <p className="text-[10px] text-gray-600">Progress:</p>
                      {/* <div className="flex justify-center items-center w-8 h-8 rounded-full bg-lime-300 shadow-inner">
                        <p className="text-sm font-bold">{action.userActionProgress}%</p>
                      </div> */}
                      <div className='h-10 w-10 z-0 relative'>
                        <CircularProgressbarWithChildren
                          value={actionProgress}
                          circleRatio={0.75}
                          styles={{
                            path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                            trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                          }}
                        >
                          <div><p className='text-xs font-bold text-orange-600'>{actionProgress}%</p></div>
                        </CircularProgressbarWithChildren>
                      </div>
                    </div>
                  </div>

                  {/* Action Name */}
                  <div className="text-sm font-semibold text-gray-800">
                    {action.userActionName}
                  </div>

                  {/* Progress Trail Section */}
                  {action.userActionProgressTrail?.length > 0 && (
                    <div className="mt-2">
                      <p className="text-[10px] text-orange-700 font-bold mb-1">Progress Updates:</p>
                      <div className="space-y-1">
                        {action.userActionProgressTrail
                        .slice()
                        .sort(
                            (a, b) =>
                                new Date(b.actionNoteDate) -
                                new Date(a.actionNoteDate)
                        )
                        ?.map((progressPoint, ptIndex) => (
                          <div
                            key={progressPoint._id + ptIndex}
                            className="flex justify-between items-center bg-gray-50 rounded px-2 py-1 text-[10px] text-gray-700 border border-gray-200"
                          >
                            <p className="truncate">{progressPoint.actionNoteText}</p>
                            <div className="flex items-center space-x-1">
                              <p className="font-bold">{progressPoint.actionNoteProgress}%</p>
                              <p className="text-gray-400 text-[8px]">
                                {new Date(progressPoint.actionNoteDate).toLocaleDateString()}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )})
            )}

            {filteredActions.length === 0 && (
              <div className="text-center text-gray-500 italic text-sm">
                  No actions recorded during this period.
              </div>
            )}

            {/* Conversations */}
            {/* Conversations Summary Card with Toggle */}
            <div className="bg-white border border-orange-400 rounded shadow-md p-4 mb-2">
              <div className="grid grid-cols-2 justify-start items-center">
                <div className='col-span-1 flex justify-start items-center'>
                  <div
                    onClick={() => setShowConversationDetails(prev => !prev)}
                    className="flex justify-center items-center w-6 h-6 text-orange-600 cursor-pointer rounded-full "
                  >
                      {showConversationDetails ? (
                        <MinusIcon className="h-5 w-5" />
                      ) : (
                        <PlusIcon className="h-5 w-5" />
                      )}                 
                  </div>
                  <div className='flex flex-col justify-start items-start'>
                    <div className='mx-3'>
                      <EtWabConversationIcon1SVGComp className='h-10 w-10 text-orange-600'/>
                    </div>
                    {/* <p className='text-lg mx-1 px-1 font-bold text-orange-700'>Conversations</p> */}
                    <p className='text-sm mx-1 px-1 font-bold text-orange-700'>Conversations</p>
                    {/* <p className='text-xs mx-1 px-2 text-white rounded-full bg-orange-600'>Conversations</p> */}
                  </div>
                </div>
                
                <div className='col-span-1'>

                  <div className='grid grid-cols-4 justify-start gap-2 text-[10px] xl:text-xs mb-1  '>
                    <div className='col-span-3'>
                      <p className="text-gray-800 inline-block rounded-full bg-yellow-300 py-[1px] my-1 px-2">All</p>
                    </div>
                    <div className='col-span-1 mx-1'>
                      <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-100 border border-gray-300">
                        <p className="text-xs font-semibold">{filteredConversations.filter(c => c.conversationSourceType === 'All').length}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className='grid grid-cols-4 justify-start gap-2 text-[10px] xl:text-xs mb-1  '>
                    <div className='col-span-3'>
                      <p className="inline-block rounded-full bg-lime-400 py-[1px]  px-2">Contact</p>
                    </div>
                    <div className='col-span-1 mx-1'>
                      <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-100 border border-gray-300">
                        <p className="text-xs font-semibold">{filteredConversations.filter(c => c.conversationSourceType === 'Contact').length}</p>
                      </div>
                    </div>
                  </div>

                  <div className='grid grid-cols-4 justify-start text-[10px] xl:text-xs mb-1 pt-2 mt-2 border-t'>
                    <div className='col-span-3'>
                      <p className="font-bold text-sm text-gray-800 inline-block py-[1px] my-1 px-2">Total</p>
                    </div>
                    <div className='col-span-1 flex justify-center items-center rounded-full bg-gray-100 shadow-md shadow-black'>
                      <p className="text-sm font-bold text-orange-600">{filteredConversations.length}</p>
                    </div>
                  </div>

                </div>

              </div>
            </div>

            {/* Detailed Conversation Tiles */}
            {showConversationDetails && filteredConversations.length > 0 && (
              filteredConversations
              .slice()
              .sort((a, b) => {
                const dateA = new Date(a.userConversationAllNoteDate || a.userConversationContactNoteDate);
                const dateB = new Date(b.userConversationAllNoteDate || b.userConversationContactNoteDate);
                return dateB - dateA; // Descending
              })
              ?.map((conversation, index) => {
                const noteText = conversation.userConversationAllNoteText || conversation.userConversationContactNoteText || '';
                const noteDate = conversation.userConversationAllNoteDate || conversation.userConversationContactNoteDate || '';

                return (
                  <div
                    key={conversation._id + index}
                    className="bg-white border border-orange-300 rounded shadow-md p-3 space-y-2"
                  >
                    {/* Header Row */}
                    <div className="flex justify-between items-center border-b mb-2 pb-2">
                      {/* Left: Index and badge */}
                      <div className="flex justify-start items-center space-x-2">
                        {/* Index */}
                        <div className="flex justify-center items-center w-6 h-6 rounded-full bg-orange-100 border border-orange-400">
                          <p className="text-xs font-bold text-orange-700">{index + 1}</p>
                        </div>
                        <div className='flex justify-start items-center'>
                          <div className='mx-1'>
                            <EtWabConversationIcon1SVGComp className='h-8 w-8 text-orange-600'/>
                          </div>
                          <p className='text-xs mx-1 px-1 font-bold text-orange-700'>Conversation</p>
                        </div>
                      </div>

                      {/* Badge for Contact or All */}
                      <div className={`text-[10px] font-semibold px-2 py-[2px] capitalize rounded-full ${
                        conversation.conversationSourceType === 'Contact' ? 'bg-orange-600 text-white' : 'bg-gray-300'
                      }`}>
                        {conversation.conversationSourceType}
                      </div>

                      {/* Date */}
                      <div className="text-[8px] text-gray-400">
                        {noteDate ? new Date(noteDate).toLocaleDateString() : ''}
                      </div>
                    </div>

                    {/* Conversation Note Text */}
                    <div className="text-sm text-gray-700 fix-nested-lists" dangerouslySetInnerHTML={{ __html: noteText }} />
                  </div>
                );
              })
            )}
            {/* If no conversations */}
            {filteredConversations.length === 0 && (
              <div className="bg-white border border-orange-300 rounded shadow-md p-3 space-y-2">
                <p className="text-center text-gray-500 text-sm">
                🧠 No conversations recorded during this period.
              </p>
              </div>
              
            )}

            {/* Creations */}
            {/* Creation Summary Card with Toggle */}
            <div className="bg-white border border-orange-400 rounded shadow-md p-4 mb-2">
              <div className="grid grid-cols-2 justify-start items-center">
                {/* Left Side: Title and Toggle */}
                <div className="col-span-1 flex justify-start items-center">
                  <div
                    onClick={() => setShowCreationDetails(prev => !prev)}
                    className="flex justify-center items-center w-6 h-6 text-orange-600 cursor-pointer rounded-full"
                  >
                    {showCreationDetails ? (
                      <MinusIcon className="h-5 w-5" />
                    ) : (
                      <PlusIcon className="h-5 w-5" />
                    )}
                  </div>
                  {/* <div className="flex justify-start items-center"> */}
                  <div className="flex flex-col justify-start items-start">
                    {/* <div className="mx-1"> */}
                    <div className="mx-3">
                      <EtWabCreationIcon1SVGComp className="h-10 w-10 text-orange-600" />
                    </div>
                    <p className='text-sm mx-1 px-1 font-bold text-orange-700'>Creations</p>
                    {/* <p className="text-lg mx-1 px-1 font-bold text-orange-700">Creations</p> */}
                  </div>
                </div>

                {/* Right Side: Count */}
                <div className="col-span-1 flex justify-center items-center">
                  <div className="flex justify-center items-center w-10 h-10 rounded-full bg-gray-100 shadow-md shadow-black">
                    <p className="text-sm font-bold text-orange-600">{filteredCreations.length}</p>
                  </div>
                </div>
                
                {/* ⬇️ Insert New: Creation Type Breakdown - we wil replace this with a Et Pixel tiled grid view
                <div className="grid grid-cols-2 gap-1 mt-2 text-[10px] xl:text-xs">
                  {Object.entries(creationTypeCounts).map(([typeName, count], index) => (
                    <div key={index} className="flex justify-between items-center bg-gray-50 rounded px-2 py-1">
                      <p className="font-semibold text-gray-700">{typeName}</p>
                      <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-100 border border-gray-300">
                        <p className="text-xs font-semibold">{count}</p>
                      </div>
                    </div>
                  ))}
                </div> */}

              </div>
            </div>
            {/* Detailed Creation Tiles */}
            {showCreationDetails && filteredCreations.length > 0 && (
              filteredCreations
                .slice()
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Newest first
                .map((creation, index) => (
                  <div
                    key={creation._id + index}
                    className="bg-white border border-orange-300 rounded shadow-md p-3 space-y-2"
                  >
                    {/* Header Row */}
                    <div className="flex justify-between items-center border-b mb-2 pb-2">
                      {/* Left: Index + Icon + Label */}
                      <div className="flex justify-start items-center space-x-2">
                        <div className="flex justify-center items-center w-6 h-6 rounded-full bg-orange-100 border border-orange-400">
                          <p className="text-xs font-bold text-orange-700">{index + 1}</p>
                        </div>
                        <div className="flex justify-start items-center">
                          <div className="mx-1">
                            <EtWabCreationIcon1SVGComp className="h-8 w-8 text-orange-600" />
                          </div>
                          <p className="text-xs mx-1 px-1 font-bold text-orange-700">Creation</p>
                        </div>
                      </div>

                      {/* Right: Type badge */}
                      {creation.userCreationType?.creationTypeName && (
                        <div className="text-[10px] font-semibold px-2 py-[2px] capitalize rounded-full bg-yellow-300 text-gray-700">
                          {creation.userCreationType.creationTypeName}
                        </div>
                      )}
                    </div>

                    {/* Creation Name */}
                    <div className="text-sm font-semibold text-gray-800">
                      {creation.userCreationName}
                    </div>

                    {/* Creation Description */}
                    {creation.userCreationDesc && (
                      <div
                        className="text-[10px] text-gray-600 leading-snug mt-1"
                        dangerouslySetInnerHTML={{ __html: creation.userCreationDesc }}
                      />
                    )}

                    {/* Created Date */}
                    <div className="border-t mt-2 pt-2 flex justify-between items-center text-[10px] text-gray-400">
                      <p>
                        Created on: {creation.createdAt ? new Date(creation.createdAt).toLocaleDateString() : "N/A"}
                      </p>
                      {creation.userMagicMomentId && (
                        <span className="bg-purple-600 text-white px-2 py-[2px] rounded-full text-[8px] font-semibold">
                          ✨ Magic Moment
                        </span>
                      )}
                    </div>
                  </div>
                ))
            )}


            {/* Contributions */}        
            <EtTranscriptSection
              title="Contributions"
              icon={EtWabContributionIcon1SVGComp}
              data={filteredContributions}
              sourceField="contributionSourceType"
              allLabel="All"
              contactLabel="Contact"
              showDetails={showContributionDetails}
              setShowDetails={setShowContributionDetails}
              renderNoteText={(item) => item.userContributionAllNoteText || item.userContributionContactNoteText}
              renderNoteDate={(item) => item.userContributionAllNoteDate || item.userContributionContactNoteDate}
              noteTypeField="userContributionTypeId.contributionTypeName"
              typePicField="userContributionTypeId.pic"
              magicMomentKey="userMagicMomentId"
            />

            {/* Impacts */}
            <EtTranscriptSection
              title="Impacts"
              icon={EtWabImpactIcon1SVGComp}
              data={filteredImpacts}
              sourceField="impactSourceType"
              allLabel="All"
              contactLabel="Contact"
              showDetails={showImpactDetails}
              setShowDetails={setShowImpactDetails}
              renderNoteText={(item) => item.userImpactAllNoteText || item.userImpactContactNoteText}
              renderNoteDate={(item) => item.userImpactAllNoteDate || item.userImpactContactNoteDate}
              noteTypeField="userImpactTypeId.impactTypeName"
              typePicField="userImpactTypeId.pic"
              magicMomentKey="userMagicMomentId"
            />

            {/* Wins */}
            <EtTranscriptSection
              title="Wins"
              icon={EtWabWinIcon1SVGComp}
              data={filteredWins}
              sourceField="winSourceType"
              allLabel="All"
              contactLabel="Contact"
              showDetails={showWinDetails}
              setShowDetails={setShowWinDetails}
              renderNoteText={(item) => item.userWinAllNoteText || item.userWinContactNoteText}
              renderNoteDate={(item) => item.userWinAllNoteDate || item.userWinContactNoteDate}
              noteTypeField="userWinTypeId.winTypeName"
              typePicField="userWinTypeId.pic"
              magicMomentKey="userMagicMomentId"
            />

            {/* Challenges */}
            <EtTranscriptSection
              title="Challenges"
              icon={EtWabChallengeIcon1SVGComp}
              data={filteredChallengeWABs}
              sourceField="challengeWABSourceType"
              allLabel="All"
              contactLabel="Contact"
              showDetails={showChallengeWABDetails}
              setShowDetails={setShowChallengeWABDetails}
              renderNoteText={(item) => item.userChallengeWABAllNoteText || item.userChallengeWABContactNoteText}
              renderNoteDate={(item) => item.userChallengeWABAllNoteDate || item.userChallengeWABContactNoteDate}
              noteTypeField="userChallengeWABTypeId.userChallengeTypeName"
              typePicField="userChallengeWABTypeId.pic"
              magicMomentKey="userMagicMomentId"
            />

            {/* Intentions */}
           <EtTranscriptSection
              title="Intentions"
              icon={EtWabIntentionIcon1SVGComp}
              data={filteredIntentions}
              sourceField="intentionSourceType"
              allLabel="All"
              contactLabel="Contact"
              showDetails={showIntentionDetails}
              setShowDetails={setShowIntentionDetails}
              renderNoteText={(item) => item.userIntentionAllNoteText || item.userIntentionContactNoteText}
              renderNoteDate={(item) => item.userIntentionAllNoteDate || item.userIntentionContactNoteDate}
              noteTypeField="userIntentionTypeId.intentionTypeName"
              typePicField="userIntentionTypeId.pic"
              magicMomentKey="userMagicMomentId"
            />

            {/* Gratitudes */}
            <EtTranscriptSection
              title="Gratitudes"
              icon={EtWabGratitudeIcon1SVGComp}
              data={filteredGratitudes}
              sourceField="gratitudeSourceType"
              allLabel="All"
              contactLabel="Contact"
              showDetails={showGratitudeDetails}
              setShowDetails={setShowGratitudeDetails}
              renderNoteText={(item) => item.userGratitudeAllNoteText || item.userGratitudeContactNoteText}
              renderNoteDate={(item) => item.userGratitudeAllNoteDate || item.userGratitudeContactNoteDate}
              noteTypeField="userGratitudeTypeId.gratitudeTypeName"
              typePicField="userGratitudeTypeId.pic"
              magicMomentKey="userMagicMomentId"
            />
            
          </div>
        )}
        
        {activeTab === 'journey' && `🗺️ Your journey map till ${activePeriod}`}
      
      
      </div>

    </div>
  );
};

const extractNotes = (accomplishments, notesFieldName, allNotesField, contactNotesField, sourceTypeLabel) => {
  const notes = [];

  accomplishments?.forEach(accomplishment => {
    const noteWrapper = accomplishment?.[notesFieldName]?.[0]?.[`${notesFieldName.slice(0, -1)}Id`] || null;

    if (noteWrapper) {
      noteWrapper?.[allNotesField]?.forEach(note => {
        notes.push({
          ...note,
          [sourceTypeLabel]: 'All',
        });
      });

      noteWrapper?.[contactNotesField]?.forEach(note => {
        notes.push({
          ...note,
          [sourceTypeLabel]: 'Contact',
        });
      });
    }
  });

  return notes;
};


export default EtTrinityWebCelebrateMagicLog; 